<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="(profile.organization.modules.filter(m => m.name === 'export').length > 0)"
        :loading="loadingExport"
        :disabled="loadingExport"
        dark
        color="export"
        class="mb-2 ml-2"
        v-bind="attrs"
        v-on="on"
        @click="exportData({sourceType: sourceType, type: exportType, params: params})"
      >
        Export
        <v-icon
          dark
        >
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <span>{{ $t('data_export') }}</span>
  </v-tooltip>
</template>

<script>
  import { call, get } from 'vuex-pathify'

  export default {
    name: 'ExportBtn',

    props: {
      sourceType: {
        type: String,
        default: '',
      },
      exportType: {
        type: String,
        default: 'xlsx',
      },
      params: {
        type: Object,
        default: () => ({}),
      },
      color: {
        type: String,
        default: 'primary',
      },
    },
    data: () => ({
      module_on: false,
    }),
    computed: {
      loadingExport: get('exportData/loading'),
      profile: get('auth/profile'),
      icon () {
        switch (this.exportType) {
          case 'xlsx':
            return '$xlsx'
          case 'pdf':
            return '$pdf'
          default:
            return ''
        }
      },
    },
    methods: {
      exportData: call('exportData/export'),
    },
  }
</script>
